module.exports = __webpack_public_path__ + "img/food5.41068250.jpg";